import inicialState from './lamina.state';
import * as actions from './lamina.action';

const RC_laminaReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.MODAL_JUSTIFICATIVA:
      return {
        ...state,
        modalJustificativa: action.payload.modalJustificativa,
      };

    case actions.MODAL_LAMINA:
      return {
        ...state,
        modalLamina: action.payload.modalLamina,
      };
    case actions.ATUALIZAR_LISTAGEM_LAMINAS:
      return {
        ...state,
        listarLaminas: action.payload.listarLaminas,
      };

    case actions.CARREGAR_LAMINAS:
      return {
        ...state,
        carregarLaminas: action.payload.carregarLaminas,
      };

    case actions.ALTERAR_TEXT_LAMINA:
      return {
        ...state,
        laminaText: action.payload.laminaText,
      };
    case actions.ALTERAR_ID_LAMINA:
      return {
        ...state,
        laminaId: action.payload.laminaId,
      };
    case actions.ALTERAR_EDICAO:
      return {
        ...state,
        isEdicao: action.payload.isEdicao,
      };
    case actions.CARREGAR_EDICAO:
      return {
        ...state,
        carregarEdicao: action.payload.carregarEdicao,
      };
    case actions.ALTERAR_TAB:
      return {
        ...state,
        activeTab: action.payload.activeTab,
      };
    default:
      return state;
  }
};

export default RC_laminaReducer;



// WEBPACK FOOTER //
// ./src/app/common/requisicaoCongelacao/tabs/lamina/lamina.reducer.js